module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Copy_16"],"path":[{"$":{"d":"M13,11v3H0V4H4V6H2v6h9V11ZM6,9V8H5v2H7V9ZM6,5H5V7H6ZM6,3H7V2H5V4H6Zm4,0V2H8V3Zm3,0V2H11V3ZM8,9v1h2V9Zm6-7V3h1V4h1V2Zm1,5h1V5H15ZM11,9v1h2V9Zm4,0H14v1h2V8H15Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Copy_16.svg
// module id = bC3r
// module chunks = 1